import './welcome.css';

const Welcome = () => {
    return (
        <section style={{ minHeight: "calc(100vh - 109px)" }} className="container">
            <div id="about" className="wrapper">
                <h1>Elena Khaletska</h1>
                <p className="intro">iOS intern at Pipedrive, kood/Jõhvi student. I am passionate about turning stunning designs into seamless user experiences. With a technical mind and over 5 years of experience in various engineering roles, I am equally able to work independently and as a collaborative team player.
                    <br />
                    <br />
                    My favorite tools include, but not limited by Swift, React, TypeScript, and Golang. I am always ready to dive into new technologies to ensure the best outcomes for all. Feel free to explore the page, and don't hesitate to reach out with any questions or just for a friendly chat.</p>
            </div>
        </section>
    )
}

export default Welcome;